import PropTypes from "prop-types";
import { observer } from "mobx-react";
// @mui
import { useTheme } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
// theme
import { bgBlur } from "@/theme/css";
// hooks
import { useOffSetTop } from "@/hooks/use-off-set-top";
import { useResponsive } from "@/hooks/use-responsive";
// components
import Logo from "@/components/logo";
import SvgColor from "@/components/svg-color";
import { useSettingsContext } from "@/components/settings";
//
import HamburgerMenu from "@/assets/icons/navbar/ic_menu_item.svg";
import { HEADER, NAV } from "../config-layout";
import {
  AccountPopover,
  // SettingsButton,
  // LanguagePopover,
  NotificationsPopover,
} from "../_common";
import { Typography } from "@mui/material";
import { ErrorBoundary } from "../../components/error/error-boundary";
import { useCurrentUser } from "@/hooks/useCurrentUser";
// import { profile } from 'console';

// ----------------------------------------------------------------------

export const Header = observer(({ onOpenNav }) => {
  const theme = useTheme();

  const settings = useSettingsContext();

  const isNavHorizontal = settings.themeLayout === "horizontal";

  const isNavMini = settings.themeLayout === "mini";

  const lgUp = useResponsive("up", "lg");

  const offset = useOffSetTop(HEADER.H_DESKTOP);

  const offsetTop = offset && !isNavHorizontal;

  const currentUser = useCurrentUser();

  const showNotification =
    currentUser.role === "teacher" || currentUser.role === "climber";

  const renderContent = (
    <>
      {lgUp && isNavHorizontal && <Logo sx={{ mr: 2.5 }} />}

      {!lgUp && (
        <IconButton onClick={onOpenNav}>
          <SvgColor src={HamburgerMenu} />
        </IconButton>
      )}

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{ xs: 0.5, sm: 1 }}
      >
        {currentUser.role === "climber" && (
          <Typography
            variant="subtitle2"
            sx={{
              fontFamily: "Proxima Nova",
              color: "#118D57",
              fontWeight: 700,
            }}
          >
            {currentUser.xp} XP
          </Typography>
        )}
        {showNotification && (
          <ErrorBoundary
            errorMessage="Could not display Notifications"
            fatal={false}
          >
            <NotificationsPopover />
          </ErrorBoundary>
        )}
        {/* <SettingsButton /> */}

        <AccountPopover />
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        boxShadow: "none",
        zIndex: 1000,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(["height"], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          height: HEADER.H_DESKTOP,
          ...(offsetTop && {
            height: HEADER.H_DESKTOP_OFFSET,
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: "background.default",
            height: HEADER.H_DESKTOP_OFFSET,
            borderBottom: `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI + 1}px)`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
});

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default Header;
